import AxiosRequestBuilder from '@/utils/axios-request-builder'
import { Endpoints, urlBuilder } from '@/connectors/endpoints'
import { arrayMapper } from '@/mappers'
import { IPayments } from '@/types/payments'
import { paymentsMap } from '@/mappers/payments'

const getPayments = (moid: number) => {
  return new AxiosRequestBuilder<IPayments[]>({
    url: urlBuilder(Endpoints.GET_PAYMENTS, String(moid)),
    method: 'get',
    responseMapperFunction: arrayMapper,
    responseMapper: paymentsMap
  }).exec().then((response) => response.data)
}

export default getPayments
